<template>
	<div class="skill-item tw-p-4 custom-fade-in">
		<div class="tw-flex tw-justify-between tw-items-center tw-gap-4">
			<span class="text-lg"
				><b>{{ skill.name }}</b> ({{ skill.parent.name }})</span
			>
			<div class="tw-flex tw-gap-4 tw-items-center">
				<close-icon class="cursor-pointer" @click="$emit('closeClicked')"></close-icon>
			</div>
		</div>
		<p-horizontal-divider mx="-1rem" my="1rem" />
		<section class="tw-flex tw-gap-6">
			<div class="tw-w-2/3">
				<p class="tw-text-app-color-primary tw-mb-1">Descripción</p>
				<p class="tw-m-0">
					{{ propOr('-', 'description', skill) }}
				</p>
			</div>
			<div class="tw-flex tw-justify-center tw-items-center tw-w-1/3" :class="[has('selectedLevel', skill) ? '' : 'tw-justify-end']">
				<div v-if="has('selectedLevel', skill)">
					<div class="tw-mb-2">
						<b :style="{ color: textToColor(path(['selectedLevel', 'name'], skill)) }">
							{{ path(['selectedLevel', 'name'], skill) }}
						</b>
						<p class="tw-text-app-color-font tw-m-0">
							{{ path(['selectedLevel', 'description'], skill) }}
						</p>
					</div>
					<p-button
						rounded-level="rounded"
						size="small"
						:outlined="true"
						@click="$emit('chooseLevelClicked')"
					>
						Cambiar
					</p-button>
				</div>
				<p-button
					v-if="!has('selectedLevel', skill)"
					@click="$emit('chooseLevelClicked')"
					type="secondary"
					rounded-level="rounded"
				>
					Escoger Nivel
				</p-button>
			</div>
		</section>
		<p-horizontal-divider
			v-if="has('selectedLevel', skill)"
			mx="-1rem" my="1rem" />
		<section v-if="has('selectedLevel', skill)" class="tw-flex tw-flex-col tw-justify-between tw-items-center">
			<div class="tw-flex tw-w-full tw-justify-between tw-items-center tw-mb-2">
				<p class="tw-text-app-color-primary text-lg">
					Seleccione de 1 a 2 preguntas
				</p>
				<question-type-selector
					:questions-type="skill.questionsType"
					@questionTypeChanged="changeQuestionType"
				></question-type-selector>
			</div>
			<div class="tw-flex tw-flex-col tw-justify-center tw-items-center">
				<p-button
					v-if="skill.selectedQuestions.length < 2 "
					roundedLevel="rounded"
					type="primary"
					@click="$emit('chooseQuestionsClicked')">+ Escoger Preguntas
				</p-button>
				<evaluation-question-sortable-list
				:questions="skill.selectedQuestions || []"
				:questions-type="skill.questionsType"
				@removeClicked="handleRemoveQuestions($event, skill)"
				@onSortedQuestionsChange="handleSortedQuestionsList($event, skill)"
			/>
			</div>
		</section>
	</div>
</template>

<script>
import { has, path, propOr, assoc } from 'ramda';
import PButton from '@/modules/shared/components/ui/p-button';
import PHorizontalDivider from '@/modules/shared/components/ui/p-horizontal-divider';
import CloseIcon from '@/modules/shared/components/icons/close-icon';
import textToColor from '@/modules/shared/utils/textToColor';
import QuestionTypeSelector from '@/modules/three-sixty-evaluation/components/third-step/components/question-type-selector';
import EvaluationQuestionSortableList from '@/modules/three-sixty-evaluation/components/third-step/components/evaluation-question-sortable-list';
import { removeElementInList } from '@/modules/shared/utils/listElements';

export default {
	name: 'SkillItem',
	props: ['skill'],
	data() {
		return {
		};
	},
	components: {
		CloseIcon,
		PButton,
		PHorizontalDivider,
		QuestionTypeSelector,
		EvaluationQuestionSortableList,
	},
	methods: {
		propOr,
		path,
		has,
		textToColor,
		changeQuestionType(typeQuestions) {
			this.questionsType = typeQuestions;
			this.$emit('questionTypeChanged', typeQuestions);
		},
		handleRemoveQuestions(selectedQuestion, skill) {
			const updatedSelectedQuestions = removeElementInList(
				selectedQuestion,
				skill.selectedQuestions,
			);
			const updatedSkill = assoc('selectedQuestions', updatedSelectedQuestions, skill);
			this.$emit('onSkillUpdate', updatedSkill);
		},
		handleSortedQuestionsList(updatedQuestions, skill) {
			const updatedSkill = assoc('selectedQuestions', updatedQuestions, skill);
			this.$emit('onSkillUpdate', updatedSkill);
		},
	},
};
</script>

<style lang="scss">
.skill-item {
	border: 1px solid var(--app-color-gray);
	border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/modules/job-profile/components/sixth-step/skill-item.vue